import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { replaceByElement } from "../../../../../utils/Logs";

interface IProps {
  benefitPlan: string;
}

export default function BenefitExpired(props: IProps) {
  const { benefitPlan } = props;
  const { t } = useTranslation();

  return useMemo(
    () =>
      replaceByElement(
        t("log.benefit_has_expired"),
        "{benefitName}",
        benefitPlan
      ),
    [benefitPlan, t]
  );
}
